import CommandsService from "@/api/services/commands.service";
import { ActionType } from "@/models/enum-types/action-type.enum";
import DeviceViewData from "@/models/modelView/IDeviceView";
import IDeviceStore from "@/models/modelStore/IDeviceStore";
import { ModemStrategy } from "./modem.strategy";
import DeviceUtil from "@/utils/device.util";
import IPosition from "@/models/dto/position.dto";
import IDataInfo from "@/models/modelView/IDataInfo";

export default class Gv55WStrategy extends ModemStrategy {
    getExtraAttributes(attributes: any): IDataInfo[] {
        return []
    }
    getReportDetails(data: IPosition[], device: IDeviceStore) {
        return this.genericReportDetails(data, device)
    }

    customAttributes: any[] = [
        { name: "odometer", viewName: "Odo:", suffix: ' Km', factor: 0.001, precision: 0 },
        { name: "power", viewName: "Voltage:", suffix: ' V' }
    ]


    async sendCommand(deviceId: number, type: ActionType, data?: string) {
        let command = ''
        switch (type) {
            case ActionType.LOCK_COMMAND:
                command = 'AT+GTOUT=gv55w,1,,,,,,,,,,,,,,,,FFFF$'
                break;
            case ActionType.UNLOCK_COMMAND:
                command = 'AT+GTOUT=gv55w,0,,,,,,,,,,,,,,,,FFFF$'
                break;
            case ActionType.OPEN_LATCHES_COMMAND:
                command = 'AT+GTOUT=gv55w,,,,1,5,1,,,,,,,,,,,FFFF$'
                break;
            case ActionType.ODOMETER_COMMAND:
                command = 'AT+GTCFG=gv55w,gv55w,gv55w,1,' + data + ',0,,37,0,,280C,0,0,0,30,0,1,0,0,8,0,FFFF$'
                break;
            case ActionType.RESET:
                command = 'AT+GTRTO=gv55w,3,,,,,,FFFF$'
                break;
            case ActionType.CUSTOM_COMMAND:
                command = data || ''
                break;
            default:
                break;
        }
        await CommandsService.sendCommand(command, deviceId);
    }

    mapDevice(device: IDeviceStore): DeviceViewData {
        return {
            data_icons: this.mapIcons(device),
            data_info: this.mapAttributes(device.position?.attributes, device),
            icon: device.icon || '0',
            id: device.id,
            plate: device.name,
            time: device.position?.deviceTime || device.position?.serverTime || device.position?.fixTime || '',
            speed: DeviceUtil.formatKnToKmh(device.position?.speed)
        }
    }

    mapIcons(device: IDeviceStore) {
        const attributes = device?.position?.attributes;
        const array = []
        if (attributes?.ignition) {
            array.push({
                classes: ['icon-data', 'key-green'],
                src: require('@/assets/img/key-green.svg'),
                extra: ''
            })
        } else {
            array.push({
                classes: ['icon-data', 'key-red'],
                src: require('@/assets/img/key-red.svg'),
                extra: ''
            })
        }
        if (attributes?.out1) {
            array.push({
                classes: ['icon-data', 'locked-car'],
                src: require('@/assets/img/locked-car.svg'),
                extra: ''
            })
        }
        return array;
    }



}